import PartnerSlider from './components/PartnerSlider.vue';
import InitLazyComponent from 'Main/modules/InitLazyComponent';

const PartnerSliders = document.querySelectorAll('.partners-slider__app');
const initLazyComponent = new InitLazyComponent({
  selectors: PartnerSliders,
  components: { PartnerSlider },
  template: '<PartnerSlider />',
});

initLazyComponent.init();
